const highlights = [
  { icon: 'ri-stack-line', tone: 'bg-primary-100 text-primary-700', value: '12 部', label: '本周连载更新' },
  { icon: 'ri-calendar-2-line', tone: 'bg-accent-100 text-accent-700', value: '48 话', label: '本周更新话数' },
  { icon: 'ri-eye-line', tone: 'bg-secondary-100 text-secondary-800', value: '5 天', label: '周一到周五连载' },
  { icon: 'ri-bookmark-line', tone: 'bg-primary-100 text-primary-700', value: '3 部', label: '周六日更新作品' },
];

export default function UpdateHighlights() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-4 md:px-6">
      <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
        {highlights.map((h) => (
          <div
            key={h.label}
            className="flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-5"
          >
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${h.tone}`}>
              <i className={`${h.icon} text-xl`}></i>
            </span>
            <div>
              <p className="font-heading text-xl text-foreground-950">{h.value}</p>
              <p className="text-xs text-foreground-500">{h.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}